'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.assessmentQuiz', {
    url: '/assessment',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow('instance.app.assessmentQuiz');
      },
      quiz: function (flow, $http, instance) {
        return $http.get('/api/v1/instances/' + instance._id + '/quizzes/assessment').then(_.property('data'));
      }
    },
    views: {
      '': {
        templateUrl: '/app/states/assessmentQuiz/assessmentQuiz.html',
        controller: function ($window, $scope, $state, instance, quiz) {
          if (!quiz) {
            return;
          }
          $scope.instance = instance;
          $scope.quiz = quiz;

          $scope.answered = [];

          $scope.current = 0;
          $scope.question = quiz.questions[$scope.current];

          $scope.prev = function () {
            if ($scope.current === 0) {
              $state.go('^');
            } else {
              $scope.current--;
              $scope.question = quiz.questions[$scope.current];
            }
          };

          $scope.next = function () {
            if ($scope.answered[$scope.current]) {
              if ($scope.current === quiz.questions.length - 1) {
                quiz.answered = $scope.answered;
                $state.go('.results');
              } else {
                $scope.current++;
                $scope.question = quiz.questions[$scope.current];
              }
            }
          };

          $scope.reply = function (answer) {
            $scope.answered[$scope.current] = answer;
            $scope.next();
          };

          $scope.introCompleted = false;
          $scope.start = function () {
            $scope.introCompleted = true;
            $window.scrollTo(0, 0);
          };

        }
      }
    }
  });

  $stateProvider.state('instance.app.assessmentQuiz.results', {
    views: {
      '@instance': {
        templateUrl: '/app/states/assessmentQuiz/assessmentQuizResults.html',
        controller: function ($scope, $state, $stateParams, instance, quiz, Api) {
          $scope.instance = instance;
          $scope.quiz = quiz;
          $scope.quizType = $stateParams.quizType;
          $scope.score = _.sum(_.map(quiz.answered, 'value'));
          $scope.result = _.find(quiz.response.responses, function (response) {
            return $scope.score >= response.values.min &&  $scope.score <= response.values.max;
          });
          $scope.user.persona = $scope.result ? $scope.result.name : '';
          $scope.user.flowPassed = true;
          $scope.userAnswers = quiz.answered;
          Api.track('instance.assessment', 'pass', {}, { quiz: quiz });
          $scope.continue = function () {
            $state.go('instance.app.dashboard');
          };
        }
      }
    }
  });
});
